/**
 * @generated SignedSource<<42b8b7c6f77e8ea37543a482b2c2a45a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type salesOrderPaymentsInlineFragment$data = {
  readonly paymentIns: ReadonlyArray<{
    readonly amount: number;
    readonly createdAt: any | null;
    readonly currencyCode: string;
    readonly payerEmail: string;
    readonly externalRef: string;
    readonly salesOrder: {
      readonly id: string;
      readonly externalRef: string;
    };
  }>;
  readonly " $fragmentType": "salesOrderPaymentsInlineFragment";
};
export type salesOrderPaymentsInlineFragment$key = {
  readonly " $data"?: salesOrderPaymentsInlineFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"salesOrderPaymentsInlineFragment">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "salesOrderPaymentsInlineFragment"
};

(node as any).hash = "d36e9b265944bcf7d11c9d83ac957e11";

export default node;
